import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const ROLE_URL = '/roles/v1';

export interface ParamsRole {
  created_at_from?: string;
  created_at_to?: string;
  creator?: string;
  limit?: number;
  name?: string;
  offset?: number;
  sort_field?: '' | 'name' | 'code' | 'created_at' | 'updated_at';
  sort_order?: SORT_ORDER;
  updated_at_from?: string;
  updated_at_to?: string;
}
export interface ResponseRole extends DefaultResponse {
  data: {
    permissions: {
      group: string;
      permissions: string[];
    }[];
    data: {
      id: string;
      code: string;
      name: string;
      creator: string;
      created_at: Date;
      updated_at: Date;
      permissions: string[];
      is_default: boolean;
    }[];
  };
}
export const getRoles = async (params: ParamsRole = {}) => {
  const response = (await api({
    url: ROLE_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseRole>;

  return response.data;
};

export interface ParamsCreateRole {
  code: string;
  name: string;
  permissions: string[];
}
export const createRole = async (data: ParamsCreateRole) => {
  const response = (await api({
    url: ROLE_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

/* export interface ParamsCreatePermissions {
  groups: Array<{
    name: string;
    permissions: string[];
  }>;
  roles: Array<{
    name: string;
    permissions: string[];
  }>;
}
export const CreatePermissions = async (data: ParamsCreatePermissions) => {
  const response = (await api({
    url: `${ROLE_URL}/init-permissions`,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
}; */

export interface ParamsUpdateRole {
  name: string;
  permissions: string[];
}
export const updateRole = async (id: string, data: ParamsUpdateRole) => {
  const response = (await api({
    url: `${ROLE_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteRole = async (id: string) => {
  const response = (await api({
    url: `${ROLE_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};
